<div class="form-group primary-color-border date-picker-div">
    <div class="input-group" daterangepicker [options]="optionsVal" (applyDaterangepicker)="applyDate($event)" (hideDaterangepicker)="calendarHideDaterangepicker($event)" (showDaterangepicker)="calendarShowDaterangepicker($event)">
        <span class="form-control uneditable-input">
            <i class="fa fa-calendar" aria-hidden="true"></i>
            <span class="dateRangeStyle">{{ daterange.start | date:'M-d-y' }} - {{ daterange.end| date:'M-d-y' }}</span>
            <span class="fa" [ngClass]="{'fa-angle-down': !isActive,'fa-angle-up':isActive}"></span>
            <span class="r6Icon"></span>
        </span>
    </div>
</div>
